module.exports = __webpack_public_path__ + "static/img/ta1-1.4569873.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/ta1-1.png
// module id = 755
// module chunks = 0